import { all, call, put, takeLatest } from 'redux-saga/effects';
import API from '../../helpers/sagaApi/sagaApi';
import Actions, { SagaHomeTypes } from './sagaHomeRedux';
import AppConfig from '../../configs/AppConfig';

export function* requestGetHisobusHomePage(action) {
    const tag = '[REQUEST_GET_HISOBUS_HOME_PAGE]';
    try {
        const inputValid = true;
        if (inputValid) {
            // step 2 : validation passed..
            const response = yield call(API.requestGetHisobusHomePage);
            if (response.status === 200 && response.data.statusCode === 200) {
                if ( AppConfig.isDevelopment ) { console.log(`${tag} requestGetHisobusHomePage response :`, response.data) ;}
                yield put(Actions.getHisobusHomePageSuccess(response.data.result));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestGetHisobusHomePage failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getHisobusHomePageFailure(message));
    }
}

export default function* rootSaga() {
    yield all([
        takeLatest(SagaHomeTypes.REQUEST_GET_HISOBUS_HOME_PAGE, requestGetHisobusHomePage),
    ]);
}


// WEBPACK FOOTER //
// ./src/redux/sagaHome/sagaHomeSaga.ts